export default __webpack_public_path__ + "static/media/icn_upload_prices.d0118037.svg";